import React from 'react'
import './style.css'
import Navbar from '../../components/containers/navbar/navbar'
import Footer from '../../components/containers/footer/footer'

const Pocas = () => {
  return (
    <div>
      
      <Navbar/>
   <div>
{/*
   <div className="how_to_use">
    How To Use <br />
    Test Results
  </div>

   </div>
  <div className="gate__container">
    <div><a href="/gate" className='opacity'>G.A.T.E</a></div>
    <div><a href="/pocas" className='pocas'>POCAS</a></div>
    <div><a href="/lisa" className='opacity'>LISA</a></div>
  </div>

  <div className='dispaly_box'>
    <div className='box_bl1'></div>
    <div className='labelx'>
    <span className='gate_up'> <span className='gate_bigg'>POCAS </span> <br />
    Professional Assessment & Selection Suite:</span> <br /> <br />
      <p className=''></p>
      <p className='p_class'>POCAS is a specialized test primarily used by migration
       offices in embassies to enhance the success rate of applicants seeking visas,
        temporary residence permits, or other migration documents.
         This comprehensive assessment evaluates the professional 
         skills, knowledge, and qualifications of applicants,
          providing migration offices with valuable
       insights into their suitability for migration.</p>
    </div>
   </div>
<div className='dispaly_box'>
  <div className='labelx'>
     <p className='p_class'>The application areas of POCAS are crucial in the migration process. 
    Migration offices utilize POCAS to assess the applicants' 
    professional competencies and ensure they meet the
     required standards for migration. This includes evaluating their language proficiency, technical expertise,
     job-specific skills, and educational qualifications.</p></div>
  
     <div className='labelx'>
     <p className='p_class'>By using POCAS, migration offices can make
      informed decisions and streamline the migration process.
       The test helps identify applicants who possess the 
       necessary expertise and qualifications, ensuring that 
       individuals who meet the migration 
     requirements are granted visas or permits.
      This results in a more efficient and effective migration </p></div>
  
</div>

<div className='dispaly_box'>

<div className='labelx'>
 <span className='gate_bigg1'>Obtaining Travel or Residence Permits: </span>
 <br />
      <p className=''></p>
      <p className='p_class'>POCAS test results used  as 
      supporting assessment system when applying for travel 
      or residence permits. By assessing the individual's 
      intentions and congruency, the test provides valuable 
      insights into their genuine motives for visiting or
       settling in a country. This helps immigration
        authorities make informed decisions, ensuring that permits are granted to individuals who genuinely intend to comply with the country's
       regulations and contribute positively to society.</p>
    </div>

    <div className='labelx'>
 <span className='gate_bigg1'>Documentation Purposes: </span>
 <br />
      <p className=''></p>
      <p className='p_class'>POCAS test results serve as official
       documentation of an individual's intentions and congruency.
        These results are submitted as part of the documentation
         required for visa applications, work permits, or other legal
          purposes. By providing a standardized assessment of the
           individual's mindset and intentions,
            the POCAS test helps establish credibility
       and transparency in the immigration process.</p>
    </div>
</div>


<div className='dispaly_box1'>

<div className='labelx'>
 <span className='gate_bigg1'>Obtaining Travel or Residence Permits: </span>
 <br />
      <p className=''></p>
      <p className='p_class'>POCAS is a specialized test primarily used by migration
       offices in embassies to enhance the success rate of applicants seeking visas,
        temporary residence permits, or other migration documents.
         This comprehensive assessment evaluates the professional 
         skills, knowledge, and qualifications of applicants,
          providing migration offices with valuable
       insights into their suitability for migration.</p>
    </div>
      *

    <div className='labelx'>
 <span className='gate_bigg1'>Documentation Purposes: </span>
 <br />
      <p className=''></p>
      <p className='p_class'>POCAS is a specialized test primarily used by migration
       offices in embassies to enhance the success rate of applicants seeking visas,
        temporary residence permits, or other migration documents.
         This comprehensive assessment evaluates the professional 
         skills, knowledge, and qualifications of applicants,
          providing migration offices with valuable
       insights into their suitability for migration.</p>
    </div>
      */}
</div>

<div className="how_to_use">
    How To Use <br />
    Test Results
  </div>

   
  <div className="gate__container">
    <div><a href="/gate" className='opacity'>G.A.T.E</a></div>
    <div><a href="/pocas" className='pocas'>POCAS</a></div>
    <div><a href="/lisa" className='opacity'>LISA</a></div>
  </div>

  <div className='coming'>
   <h1 className='hw'>Coming Soon!!</h1>
  </div>

<Footer/>
</div>


  )
}

export default Pocas
